import { doGet2, doPost2 } from "./common"
import localStorageWrapper from 'util/LocalStorageWrapper'

export const getGalleryPage = (breakId, stepId, page, pageSize) => {
  let payload = {
    breakId,
    stepId,
    page,
    pageSize,
  }

  return doGet2(`/photoUpload/getGallery`, payload)
}

//Paul and i learned that the server does not like non-b64 characters; thus the MIME part of the string must be excised.
const parseDataURL = (str) => {
  return str.split('base64,')[1]
}

export const uploadPhoto = async (photo, breakId, stepid) => {

  let payload = {
    photo: parseDataURL(photo),
    breakId: breakId,
    stepId: stepid
  }

  return doPost2(`/photoUpload/upload`, payload)
}

export const getUploadImage = async breakId => {
  if (!window) return false
  try {
    return JSON.parse(localStorageWrapper.getItem(`image_${breakId}`))
  } catch (e) {
    console.log(`problem getting image upload: ${e}`)
    return false
  }
}

export const saveUploadImage = async (breakId, obj) => {
  if (!window) return false
  try {
    await localStorageWrapper.setItem(`image_${breakId}`, JSON.stringify(obj))
    return true
  } catch (e) {
    console.log(`problem setting image upload: ${e}`)
    return false
  }
}
